// extracted by mini-css-extract-plugin
module.exports = {"feature":"Feature_feature__rE_1B","mdi":"Feature_mdi__TOrUO"};